import React, { useEffect, useContext } from 'react';
import { ExperienceContext } from '@thd-nucleus/experience-context';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { Tip } from './subcomponets/Tip';
import styles from './no-results-found-banner.module.scss';
import { CustomCatalogButton } from './subcomponets/CustomCatalogButton';

const NoResultsFoundBanner = ({ keyword, cpoOnly, onCpoClick }) => {
  useEffect(() => { LIFE_CYCLE_EVENT_BUS.lifeCycle.trigger('no-results-found-banner.ready'); }, []);
  const { channel } = useContext(ExperienceContext);
  const isMobile = channel === 'mobile';

  const TRY_DIFFERENT_WORDS_TITLE = 'Try different search words';
  const TRY_DIFFERENT_WORDS_TIP = 'For example, you\'ll get different results when you search for light bulb and LED.';
  const CHECK_SPELLING_TITLE = 'Check your spelling';
  const CHECK_SPELLING_TIP = 'Catching the smallest typo can make the biggest difference!';
  const EXACT_PHRASE_TITLE = 'Use exact phrase';
  const EXACT_PHRASE_MOBILE = '(model # or brand name)';
  const EXACT_PHRASE_TIP = 'You can even enter an item number, model number or brand name.';
  const tipsClasses = classNames(styles['no-results-found-banner__tips-container'], {
    grid: !isMobile
  });
  const bodyClasses = classNames(styles['no-results-found-banner__body'], {
    [styles['no-results-found-banner__body--no-background']]: isMobile
  });

  return (
    <div className={bodyClasses}>
      <div className={styles['no-results-found-banner__title-container']}>
        <span className={`${styles['no-results-found-banner__title-container-icon']} mw-icon-search`} />
        Hmm...we couldn&apos;t find&nbsp;
        <span className={styles['no-results-found-banner__title-container-term']}>
          &quot;{keyword}&quot;
        </span>
        {cpoOnly && (<CustomCatalogButton value="false" onCpoClick={onCpoClick} />)}
      </div>
      {!isMobile && (
        <div className={tipsClasses}>
          <Tip title={TRY_DIFFERENT_WORDS_TITLE} description={TRY_DIFFERENT_WORDS_TIP} />
          <Tip title={CHECK_SPELLING_TITLE} description={CHECK_SPELLING_TIP} />
          <Tip title={EXACT_PHRASE_TITLE} description={EXACT_PHRASE_TIP} />
        </div>
      )}
      {isMobile && (
        <ul className={styles['no-results-found-banner__tip-list']}>
          <li className={styles['no-results-found-banner__tip-list-item']}>{TRY_DIFFERENT_WORDS_TITLE}</li>
          <li className={styles['no-results-found-banner__tip-list-item']}>{CHECK_SPELLING_TITLE}</li>
          <li className={styles['no-results-found-banner__tip-list-item']}>
            {`${EXACT_PHRASE_TITLE} ${EXACT_PHRASE_MOBILE}`}
          </li>
        </ul>
      )}
    </div>
  );
};

NoResultsFoundBanner.displayName = 'NoResultsFoundBanner';
NoResultsFoundBanner.propTypes = {
  keyword: PropTypes.string.isRequired,
  cpoOnly: PropTypes.bool,
  onCpoClick: PropTypes.func
};

NoResultsFoundBanner.defaultProps = {
  cpoOnly: false,
  onCpoClick: () => {}
};

export { NoResultsFoundBanner };
